<section class="lg-container">
  <div class="button-wrapper">
    <button
      mat-raised-button
      type="button"
      [routerLink]="['/lead-generation', 'projects', currentProjectId, 'creator', 'bubble']"
      color="primary" >
      {{ 'LEAD_GENERATION.CREATOR.POPUP.SWITCH_TO_BUBBLE' | translate }}
    </button>
  </div>
  <div class="grid-container"
       [ngClass]="advancedSettings ? 'advanced-settings-container' : 'basic-settings-container' "
  >
    <cc-lg-live-preview-popup
      class="live-preview"
      (previewTypeChanged)="onChangePreviewType($event)"></cc-lg-live-preview-popup>
    <a
      class="type-settings advanced-link"
      (click)="handleAdvancedSettingsClick()">
      {{advancedSettings ? ("LEAD_GENERATION.CREATOR.POPUP.BASIC_SETTINGS" | translate) : ("LEAD_GENERATION.CREATOR.POPUP.ADVANCED_SETTINGS" | translate )}}
    </a>
    <cc-lg-popup-theme-color
      class="theme-color"
      *ngIf="!advancedSettings"
      [popupSettings]="popupSettings"></cc-lg-popup-theme-color>
    <cc-lg-popup-font-box
      class="font-box"
      *ngIf="!advancedSettings"
      [popupSettings]="popupSettings"></cc-lg-popup-font-box>
    <cc-lg-popup-text-box
      class="text-box"
      *ngIf="!advancedSettings"
      [popupSettings]="popupSettings"></cc-lg-popup-text-box>

    <cc-lg-country-code
      class="forced-country-code"
      [popupSettings]="popupSettings">
    </cc-lg-country-code>


  </div>
  <div
    class="button-wrapper"
    *ngIf="!advancedSettings">
    <button
      mat-raised-button
      type="button"
      (click)="saveDb()"
      color="primary-full" >
      {{'LEAD_GENERATION.CREATOR.POPUP.PUBLISH' | translate}}
    </button>
  </div>
</section>
<div
  class="editor-wrapper"
  [class.active]="advancedSettings">
  <div
    class="editor"
    [class.popup]="isPopup">
    <cc-lg-code-box
      class="html-box"
      mode="html"
      [content]="popupSettings.get('customHTML').value"
      [insertHtml]="insertHtml"
      (codeChanged)="onChangeEditorCode($event, 'customHTML')"
      title="html editor of pop-up"
      *ngIf="isPopup"></cc-lg-code-box>
    <cc-lg-code-box
      class="html-box"
      mode="html"
      [content]="popupSettings.get('thankYouCustomHTML').value"
      (codeChanged)="onChangeEditorCode($event, 'thankYouCustomHTML')"
      title="html editor of thank you page"
      *ngIf="!isPopup"></cc-lg-code-box>
    <cc-lg-code-box
      class="css-box"
      mode="css"
      [content]="popupSettings.get('customCSS').value"
      (codeChanged)="onChangeEditorCode($event, 'customCSS')"
      title="css editor"></cc-lg-code-box>
  </div>
  <div class="footer">
    <div class="html-elements" *ngIf="isPopup" >
      {{'LEAD_GENERATION.CREATOR.POPUP.HTML_ELEMENTS' | translate }}
      <button (click)="addButton()">button</button>
      <button (click)="addInput()">input</button>
      <button (click)="addDiv()">error message</button>
    </div>
    <div class="footer-message">
      <div class="error-custom-html">
        <i class="material-icons pull-left">
          error_outline
        </i>
        <div class="error-message pull-left">
          {{'LEAD_GENERATION.CREATOR.POPUP.INSTRUCTIONS_FOR_HTML_ELEMENTS' | translate }}
        </div>
      </div>
      <button
        mat-raised-button
        type="button"
        (click)="saveDb()"
        color="primary-full"
        class="save-button">
          {{'LEAD_GENERATION.CREATOR.POPUP.PUBLISH' | translate }}
      </button>
    </div>
  </div>
</div>
